import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
// import {
//   Skeleton,
// } from '@iris-platform/iris-react-ui';
import DataProcessor from './dataprocessor';
// import Panel from '../Panel';


const styles = () => ({
  svcButton: {
    width: '70px',
    height: '50px',
    margin: '2px',
    textAlign: 'center',
    verticalAlign: 'top',
    border: '2px solid black',
    borderRadius: '5px',
  },
});

const GET_API_SERVICES = gql`
    {
      getAPIServices
    }
  `;

class ApiResponseServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.eachService = this.eachService.bind(this);
  }

  eachService(service) {
    const { props } = this;
    const {
      classes,
    } = props;
    return (
      <button onClick={props.click} type="submit" className={classes.svcButton} id={service.serviceName} key={service.serviceName}>
        {service.displayName}
      </button>
    );
  }

  render() {
    const { props } = this;
    const {
      classes,
    } = props;

    return (
      <div className={classes.pageWrapper}>
        <Query query={GET_API_SERVICES} notifyOnNetworkStatusChange>
          {({ data, loading, error }) => {
            if (error) {
              return (
                <div className={classes.panelHeader}>
                  Query returned error
                  {error}
                </div>
              );
            }
            const callData = data && data.getAPIServices && !loading
              ? DataProcessor(data) : [];
            if (callData === []) {
              return (
                <div className={classes.panelHeader}>
                  Query returned no data
                </div>
              );
            }
            return (
              <div>
                {callData.map(this.eachService)}
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}


export default withStyles(styles)(ApiResponseServices);
